const name = 'RepeatersTemplatesAspect'

const defaultModel = {
    repeaterToTemplateItem: {}
}

export {name, defaultModel}